<template>
  <div class="sickdaystatistics__report__view">
    <div class="reports__subheader">
      <period-panel
        :dateFrom="dateFrom"
        :dateTo="dateTo"
        @dateFrom="(value) => (this.dateFrom = value)"
        @dateTo="(value) => (this.dateTo = value)"
      >
      </period-panel>

      <group-panel @groupId="(value) => (groupId = value)" :addDefault="true">
      </group-panel>

      <submit-panel @submit="performLookup"> </submit-panel>
      <div class="reports__panel--submit" v-if="filteredData.length > 0">
        <b-button class="button is-primary" @click="openSidebarAsync()">
          Filtrere medarbejdere
        </b-button>
      </div>
    </div>

    <b-table
      :data="filteredData"
      :loading="loading"
      default-sort="number"
      hoverable
    >
      <b-table-column
        field="number"
        label="Ins. nr."
        v-slot="props"
        sortable
        numeric
      >
        {{ props.row.number }}
      </b-table-column>

      <b-table-column field="name" label="Inseminør" v-slot="props" sortable>
        {{ props.row.name }}
      </b-table-column>

      <b-table-column
        field="driveTimeInMinutesABK"
        label="Før 07:15 timer"
        v-slot="props"
        numeric
        cell-class="cell-note"
        sortable
      >
        {{ (props.row.driveTimeInMinutesABK / 60.0) | twodecimal }}
      </b-table-column>

      <b-table-column
        field="driveTimeInMinutesABK"
        label="Før 07:15 timer (sh)"
        v-slot="props"
        numeric
        cell-class="cell-note"
        sortable
      >
        {{ (props.row.driveTimeInMinutesSHABK / 60.0) | twodecimal }}
      </b-table-column>

      <b-table-column
        field="driveTimeInMinutesABKTimeSpan"
        label="Før 07:15 timer:minutter"
        v-slot="props"
        numeric
        sortable
      >
        {{ props.row.driveTimeInMinutesABKTimeSpan }}
      </b-table-column>

      <b-table-column
        field="driveTimeInMinutesABKTimeSpan"
        label="Før 07:15 timer:minutter (sh)"
        v-slot="props"
        numeric
        sortable
      >
        {{ props.row.driveTimeInMinutesSHABKTimeSpan }}
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import APISTATE from "@/enums/APISTATE";
import PeriodPanel from "@/components/report/PeriodPanel.vue";
import GroupPanel from "@/components/report/GroupPanel.vue";
import SubmitPanel from "@/components/report/SubmitPanel.vue";

export default {
  name: "drivestatistics-report-view",
  components: { PeriodPanel, SubmitPanel, GroupPanel },
  data: () => ({
    dateFrom: undefined,
    dateTo: undefined,
    groupId: undefined,
  }),
  async mounted() {
    this.dateFrom = new Date(new Date().getFullYear(), 0, 1);
    this.dateTo = new Date(new Date().getFullYear(), 11, 31);
  },
  methods: {
    ...mapActions("reportStore", [
      "getDriveReportForPeriod",
      "setDriveReportForPeriod",
    ]),
    ...mapActions("generalStatisticsFilteringSidebar", [
      "sidebarOpenAsync",
      "setIsOpen",
      "setGroupMembers",
      "setFilter",
    ]),
    async performLookup() {
      const dto = {
        startDate: this.dateFrom,
        endDate: this.dateTo,
        forGroup: this.groupId,
      };
      await this.getDriveReportForPeriod(dto);
    },
    async openSidebarAsync() {
      this.setGroupMembers(this.filteredData);
      await this.sidebarOpenAsync()
        .then(async (response) => {
          if (response.action === "update") {
            await this.setDriveReportForPeriod(response.markedGroupMembers);
          }
        })
        .catch((error) => console.error(error));
    },
  },
  computed: {
    ...mapGetters("reportStore", [
      "driveReportForPeriodApiState",
      "driveReportForPeriod",
    ]),
    loading() {
      return this.driveReportForPeriodApiState === APISTATE.LOADING;
    },
    validated() {
      return this.dateFrom && this.dateTo && this.groupId;
    },
    filteredData() {
      return this.driveReportForPeriod;
    },
  },
};
</script>
